/**
 * Button Component Renderer
 *
 * Renders button components with proper prop spreading and loading state handling.
 *
 * @since 6.9.0 Initial implementation
 */
import { html } from 'lit';
import { spreadProps } from '../utils/spread-props';
import { iconRenderer } from './icon';
/**
 * Allowed props for uap-app-integration-settings-button component
 */
const uoButtonAllowedProps = new Set([
    'type',
    'name',
    'value',
    'disabled',
    'loading',
    'color',
    'size',
    'href',
    'target',
    'needs-confirmation',
    'confirmation-heading',
    'confirmation-content',
    'confirmation-button-label',
    'confirmation-fields',
    'icon',
    'class',
    'row-submission',
    'integration-id',
]);
/**
 * Render a button component
 *
 * @param {ButtonData} data - The button data to render
 * @param {ComponentProps} [props={}] - Additional props to spread
 *
 * @return {TemplateResult} The rendered button component
 */
export function buttonRenderer(data, props = {}) {
    const { label, icon, ...buttonProps } = data;
    const { loading, ...restProps } = props;
    if (loading) {
        return html ``;
    }
    return html `
		<uap-app-integration-settings-button ${spreadProps(uoButtonAllowedProps)({ ...buttonProps, ...restProps })}>
			${icon ? iconRenderer(icon) : ''}
			${label || ''}
		</uap-app-integration-settings-button>
	`;
}
